import lfRequest from '@/service/index'
//获取告警记录
export function getAlarmList(params: any) {
  return lfRequest.get<any>({
    url: '/api/alarm/records',
    params: params
  })
}
//保存阈值
export function saveThresholds(data: any) {
  return lfRequest.post<any>({
    url: '/api/alarm/thresholds',
     data: data
  })
}
//清空所有告警记录
export function deleteAllAlarm() {
  return lfRequest.delete<any>({
    url: '/api/alarm/records/clear',
  })
}
//删除告警记录
export function deleteAlarm(id: string) {
  return lfRequest.delete<any>({
    url: `/api/alarm/records/${id}`,
  })
}
//标记告警为已处理
export function markAlarm(id: string) {
  return lfRequest.post<any>({
    url: `/api/alarm/records/${id}/mark-handled`,
  })
}
//获取所有阈值配置
export function getThresholds() {
  return lfRequest.get<any>({
    url: '/api/alarm/thresholds',
    params: {}
  })
}